import { DIALOG_IDS, modalStore } from '@core/modal'
import { useActions } from '@core/store'
import { shareStore, type TShareEntity } from '../store/shareStore'

/**
 * Imperative open/close seam for the share dialog. `open(entity)` seeds the shared entity then opens
 * the dialog; the share_button_click event fires in the caller (trigger) so it carries the caller's
 * placement. share_type_click + open-time analytics live in `ShareDialogContainer`.
 */
export const useShareDialog = () => {
    const actions = useActions({
        setEntity: shareStore.actions.setEntity,
        openModal: modalStore.actions.open,
        closeModal: modalStore.actions.close,
    })

    const open = (entity: TShareEntity) => {
        actions.setEntity(entity)
        actions.openModal(DIALOG_IDS.share)
    }

    const close = () => {
        actions.closeModal()
        actions.setEntity(null)
    }

    return { open, close }
}
